/// <reference types="@types/google.maps" />
import { Directive, ElementRef, OnInit, Output, EventEmitter, NgZone, Input, Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
@Directive({
    selector: '[google-places]',
    exportAs: 'ngx-google-places'
})
export class NgxGooglePlacesDirective implements OnInit {
    public element: HTMLInputElement;
    autocomplete?: google.maps.places.Autocomplete;
    eventListener?: google.maps.MapsEventListener;
    ngZone:NgZone;
    place?: google.maps.places.PlaceResult;
    @Output() onAddressChange: EventEmitter<any> = new EventEmitter();
    @Input() options?: google.maps.places.AutocompleteOptions;
    
    constructor(elRef: ElementRef, ngZone: NgZone) {
        //elRef will get a reference to the element where
        //the directive is placed
        this.element = elRef.nativeElement;
        this.ngZone = ngZone;
    }
  
    ngOnInit() {
        this.autocomplete = new google.maps.places.Autocomplete(this.element);
        this.reset();
        //Event listener to monitor place changes in the input
        if (this.autocomplete.addListener !== null)
            this.eventListener = google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
                this.handleChangeEvent();
        });
    }

    reset() {
        this.autocomplete?.setComponentRestrictions(this.options?.componentRestrictions || null);
        this.autocomplete?.setTypes(this.options?.types || []);
    }

    handleChangeEvent() {
        this.ngZone.run(() => {
            this.place = this.autocomplete?.getPlace();
            if (this.place) {
                this.onAddressChange.emit(this.place);
            }
        });
    }
}